export default function () {
  return {
    columns: [
      {
        name: 'id',
        columnProps: {
          label: '应付ID',
          prop: 'id',
          width: 100,
        },
      },
      {
        name: 'payType',
        columnProps: {
          label: '付款内容',
          prop: 'payType',

        },
      },
      {
        name: 'payDate',
        columnProps: {
          label: '应付日期',
          prop: 'payDate',

        },
      },
      {
        name: 'payAmount',
        columnProps: {
          label: '应付金额(元)',
          prop: 'payAmount',
        },
        getText: ({ row }) => this.numberWithCommas(row.payAmount),
      },
      {
        name: 'paidAmount(元)',
        columnProps: {
          label: '已付金额',
          prop: 'paidAmount',
        },
        getText: ({ row }) => this.numberWithCommas(row.paidAmount),
      },
      {
        name: 'remarks',
        columnProps: {
          label: '备注',
          prop: 'remarks',
        },
      },
      {
        name: 'payState',
        columnProps: {
          label: '付款状态',
          prop: 'payState',
        },
      },
      {
        name: 'completeTime',
        columnProps: {
          label: '付款完成时间',
          prop: 'completeTime',
          width: 160,
        },
      },
      {
        name: 'changeState',
        columnProps: {
          label: '是否变更',
          prop: 'changeState',
        },
      },
    ],
    pagination: {
      pageSize: 10,
      pageNum: 1,
      total: 0,
    },
  }
}
